import { render, staticRenderFns } from "./pictures-draggable.vue?vue&type=template&id=f7be50d0"
import script from "./pictures-draggable.vue?vue&type=script&lang=js"
export * from "./pictures-draggable.vue?vue&type=script&lang=js"
import style0 from "./pictures-draggable.vue?vue&type=style&index=0&id=f7be50d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports